export const navigation = {
  'Go back': 'Volver',
  'Go forward': 'Avanzar',
};
